import React from 'react';

const InputSelector = ({ options, value, onChange, name }) => {
  return (
    <select className='input-select-component' value={value} onChange={onChange} name={name}>
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default InputSelector;